import styled from 'styled-components';

export const Wrapper = styled.div`
    
`;

export const AccountTiersWrapper = styled.div`
    padding: 1rem 0rem 2rem 0rem;
    color: #000000;
    width: 50%;
    .content-container {
        .content-title {
            font-size: 16px;
            font-weight: bold;
        }
        .contents {
            font-size: 12px;
            color: #545454;
            margin-top: 5px;
        }
    }
    .select-container {
        margin-top: 1.5rem;
        border: 1px solid #707070;
        position: relative;
        width: 350px;
        .ant-select {
            width: 100%;
        }
        .ant-select-selection {
            padding-left: 1.5rem;
        }
        .ant-select-open {
            .ant-select-selection {
                border: none;
                border-radius: 0px;
            }
        }
        .ant-select-selection,
        .ant-select-focused  {
            border: none;
            border-radius: 0px;
        }
        .account-icon {
            position: absolute;
            top: 3px;
            width: 1.5rem;
            z-index: 1;
        }
    }
    .box-container {
        .box-wrapper {
            width: 350px;
            height: 80px;
            border: 1px solid #707070;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .flex-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex: 1;
                .file-container-label {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
                .tier-name {
                    font-size: 13px;
                    font-weight: bold;
                }
                .link {
                    font-size: 12px;
                    color: #3A4FFF;
                    text-decoration: underline;
                    cursor: pointer;
                }
                img {
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }
    .button-container {
        margin-top: 2rem;
        .ant-btn {
            width: 350px;
            height: 45px;
        }
    }
    .footer-container {
        margin-top: 0.75rem;
        font-size: 12px;
        text-align: center;
        width: 350px;
        .footer-link {
            color: #0000ff;
            text-decoration: underline;
            cursor: pointer;
        }
    }
    .file-container {
		border: 1px solid #b9b9b9;
		display: block;
		padding: 0 1rem;
		white-space: nowrap;
		position: relative;
		label {
			display: block;
			padding-bottom: 0;
			box-sizing: border-box;
			.anchor {
				color: #3A4FFF;
				text-decoration: underline;
				cursor: pointer;
			}
		}
		.ant-form-item-control {
			line-height: 1;
		}
		input {
			opacity: 0;
			position: fixed;
			left: -999px;
		}
    }
`